import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule, NgbModalModule, NgbDateParserFormatter, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { UserService } from './services/user.service';
import { AuthGuardService } from './services/auth-guard.service';
import { UnauthorizedInterceptorService } from './services/unauthorized-interceptor.service';
import { NgbdSortableHeader } from './directives/ngbd-sortable-header.directive';
import { BlockClipboardDirective } from './directives/block-clipboard.directive';
import { MonthDayYearDateParserFormatter } from './components/shared/month-day-year.dateparser';
import { SampleCorrectionValidatorDirective } from './directives/sample-correction-validator.directive';
import { SearchTipsComponent } from './components/content/search-tips/search-tips.component';
import { SampleDisplayComponent } from './components/sample-display/sample-display.component';
import { PreLogTipsComponent } from './components/content/pre-log-tips/pre-log-tips.component';
import { InputBoxComponent } from './components/shared/input-box/input-box.component';
import { DuplicateSamplePopupComponent } from './components/duplicate-sample-popup/duplicate-sample-popup.component';
import { PreLogDisplayComponent } from './components/pre-log-display/pre-log-display.component';
import { ConfigurationService } from './services/configuration.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

const initializeApp = () => {
  const configurationService = inject(ConfigurationService);
  return configurationService.load();
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    routingComponents,
    NgbdSortableHeader,
    BlockClipboardDirective,
    SampleCorrectionValidatorDirective,
    SearchTipsComponent,
    SampleDisplayComponent,
    PreLogTipsComponent,
    InputBoxComponent,
    DuplicateSamplePopupComponent,
    PreLogDisplayComponent
],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxMaskDirective
  ],
  providers: [
    UserService,
    AuthGuardService,
    provideAppInitializer(initializeApp),
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptorService, multi: true },
    { provide: NgbDateParserFormatter, useClass: MonthDayYearDateParserFormatter },
    Title,
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxMask()
  ]
})

export class AppModule { }
